<div class="container default-legend-theme default-button-theme">
  <div class="navigation">
    <div class="home" (click)="goHome()">
      <mat-icon class="icon">home</mat-icon>
      <div class="label">Home</div>
    </div>
    <div class="filler"></div>
    <app-button-group class="buttons" [items]="navigation" [value]="selected" [deselectable]="false"
                      (valueChange)="navigationChanged($event)">
      <div *appButtonContent="let item" class="button">
        <mat-icon class="icon" inline [svgIcon]="item.icon"></mat-icon>
        <div class="label">{{ item.label }}</div>
      </div>
    </app-button-group>
  </div>

  <div class="legend-view-container">
    <ng-container *ngIf="!selected.hideLegend">
      <ng-container *ngFor="let legend of legends">
        <div class="item" *ngIf="!isVariableFixed(legend.variable)">
          <div class="title">
            <mat-icon class="icon" inline [svgIcon]="legend.icon"></mat-icon>
            <span class="label">{{ legend.label + ': ' + variableLabel(legend.variable) }}</span>
          </div>
          <app-graphic-variable-legend class="content" [visualizationId]="legend.type"></app-graphic-variable-legend>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
